import { useTranslation } from "react-i18next";
import { Inbox, Layers } from "lucide-react";
import Spinner from "../../../../../components/shared/Spinner";
import EventDisplay from "./EventDisplay";
import CustomDragLayer from "./EventDisplay/CustomDragLayer";
import BulkActions from "./BulkActions";
import { useScheduleContext } from "../../hooks/context/useScheduleContext";

function UnassignedShifts({ openAssignModal, openDeleteModal, cellWidth }: any) {
    const { t } = useTranslation();
    const { unassignedEvents, loadingUnassignedEvents } = useScheduleContext();

    return (
        <div className="tw-w-1/3 tw-flex tw-flex-col tw-border tw-rounded-r-sm tw-border-l-0">
            <CustomDragLayer cellWidth={cellWidth} />

            <div className="tw-font-semibold tw-justify-between tw-text-neutral-700 tw-border-b tw-p-5 tw-flex tw-items-center tw-gap-2">
                <div className="tw-flex tw-gap-2 tw-items-center">
                    <Layers size={19} />
                    <h1>
                        {t("unassigned-shifts")}
                    </h1>
                </div>

                <BulkActions
                    openAssignModal={openAssignModal}
                    openDeleteModal={openDeleteModal}
                />
            </div>

            {/* Absolutely positioned so the list doesn't grow the row - the panel stretches to the schedule's height */}
            <div className="tw-relative tw-flex-1 tw-min-h-0">
                <div className="tw-absolute tw-inset-0 tw-p-5 tw-overflow-auto">
                    {loadingUnassignedEvents ? (
                        <div className="tw-w-full tw-flex tw-justify-center tw-py-7">
                            <Spinner className="tw-text-primary" />
                        </div>
                    ) : unassignedEvents?.length > 0
                        ? unassignedEvents.map((event: any) => <EventDisplay key={event?.id} event={event} />)
                        : (
                            <div className="tw-border tw-flex tw-justify-center tw-items-center tw-py-7 tw-flex-col tw-rounded-sm tw-text-neutral-500">
                                <Inbox size={22} className="tw-mb-1" />
                                <span className="tw-text-xs">{t("no-data")}</span>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
}

export default UnassignedShifts;
